import React, { useEffect } from 'react'

import { Session, Password, Main, Share, Certame } from 'loadable'

import { PrivateRoute } from 'components/PrivateRoute/PrivateRoute'
import { Router, Redirect, Route, Switch } from 'react-router-dom'
import history from 'utils/history'
import ScrollToTop from 'components/ScrollToTop/ScrollToTop'
import ReactGA from 'react-ga4'
import { useSessionState } from 'contexts/SessionContext'

const AppRouter = () => {
  const { user = {} } = useSessionState()

  useEffect(() => initializeAnalytics({ userId: user?.id }), [user?.id])

  return (
    <Router history={history}>
      <ScrollToTop>
        <Switch>
          <PrivateRoute path='/app' component={Main} />
          <Route path='/session' component={Session} />
          <Route path='/password' component={Password} />
          <Route path='/share' component={Share} />
          <Route path='/certame/:id' component={Certame} />
          <Route exact path='/' component={() => <Redirect to='/app' />} />
          <Route render={() => <Redirect to='/session/new' />} />
        </Switch>
      </ScrollToTop>
    </Router>
  )
}

const initializeAnalytics = ({ userId }) => {
  const trackingId = process.env.REACT_APP_GOOGLE_TRACK
  if (!trackingId || !userId) return undefined

  ReactGA.initialize([
    {
      trackingId,
      gaOptions: { userId },
    },
  ])

  return history.listen(location => {
    ReactGA.send({ hitType: 'pageview', page: location?.pathname })
  })
}

export default AppRouter
